import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_content_loader, {
          key: 0,
          style: {"width":"100%","height":"100%"}
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.isMounted)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          key: 1,
          options: {
                ..._ctx.options,
                colors: _ctx.colors,
                xaxis: { ..._ctx.options.xaxis, categories: _ctx.categories },
            },
          series: _ctx.seriesData,
          height: "100%",
          type: "bar",
          width: "90%",
          onDataPointSelection: _ctx.onChartClick
        }, null, 8, ["options", "series", "onDataPointSelection"]))
      : _createCommentVNode("", true)
  ]))
}